$(function () {
    // Check if chat items exist
    if ($('.chat-item').length > 0) {
        $('.chat-item').on('click', function () {
            // Only trigger the toggle if the screen width is 768px or less
            if ($(window).width() <= 768) {
                $('.chat-sidebar').toggleClass('sidebar-hide');
                $('.chatbar-wrap').toggleClass('chatbar-open');
                
                // Accessibility: Tell screen readers the sidebar is now hidden
                const isHidden = $('.chat-sidebar').hasClass('sidebar-hide');
                $('.chat-sidebar').attr('aria-hidden', isHidden ? 'true' : 'false');
            }
        });
    }
});


